<div class="modal-header">
    <p class="modal-title"><strong>History - Changes in critical fields</strong></p>

        <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>
<div class="modal-body" *ngIf="!historyEmpty">

    <div class="history">
        <div class="row">
            <div class="col stat">
                Created by
                <span>
                    {{model.createdByEmployee.name}}
                </span>
            </div>
            <div class="col stat">
                Last modified by
                <span>
                    {{model.modifiedByEmployee.name}}
                </span>
            </div>
        </div>

        <div class="col p-0" *ngIf="!isLoading">
            <div class="overflow-container">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Modified On</th>
                            <th scope="col" *ngFor="let header of datasource; let latest = last">
                                {{header.modifiedDate | date:'dd-MMM-yy'}}
                                <small *ngIf="isCurrentProfile && latest">
                                    <b>(Current value)</b>
                                </small>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col">Modified By</td>
                            <td scope="col" *ngFor="let header of datasource">
                                {{header.normalizedUsername}}
                            </td>
                        </tr>
                    </tbody>

                    <tbody>
                        <tr *ngFor="let text of displayTextKeys">
                            <td>
                                {{text.title}} &nbsp;&nbsp;
                            </td>
                            <td *ngFor="let data of datasource;index as i;let last = last"
                                [ngClass]="isDifferent(text.key, i, last)">
                                <span *ngIf="text.type !== 'string' ">
                                    {{ data.newData[text.key]?.DisplayText }}
                                </span>
                                <span *ngIf="text.type === 'string' ">
                                    {{ data.newData[text.key] }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngIf="amendedDataList.length >0" style="text-align: right;">
            Amendment History: <a href="javascript:void(0);"
                *ngFor="let dt of amendedDataList;index as i;let last = last" [ngClass]="{'active': selectedItem == dt}"
                (click)="LoadAmendedData($event,dt,last)">
                <span *ngIf="!last">{{i+1}}({{ dt.amendedDate | date:'dd-MMM-yy'}}) > </span><span *ngIf="last"> current
                    value </span>
            </a>
        </div>
        <div class="d-flex flex-row justify-content-between mt-3">
            <div><button class="btn btn-primary" (click)="loadPrevious()"
                    *ngIf="!noMoreHistory || isSizeExceeds">Previous</button></div>
        </div>
    </div>
</div>


<div class="modal-body" *ngIf="historyEmpty">
    <div class="d-flex justify-content-around" *ngIf="!isLoading">
        <div class="">
            No history of actions found for this profile
        </div>
    </div>
</div>